<template>
  <main-content>
    <action-bar>
      <router-link to="/money-request-create" class="btn btn-success">{{ $t('money_request.create') }}</router-link>
    </action-bar>
    <money-request-filter :action="filterAction"></money-request-filter>
    <div v-if="status === 'success'">
      <money-request-with-manage v-if="$can('read', 'payment-link')"
                                 :query="query"
                                 ref="datatable"
      />
      <money-request-without-manage v-else
                                    :query="query"
                                    ref="datatable"
      />
    </div>
  </main-content>
</template>

<script>
import mainContent from '@/components/main-content';
import moneyRequestFilter from './components/filter';
import MoneyRequestWithManage from './components/MoneyRequestWithManageAccess';
import MoneyRequestWithoutManage from './components/MoneyRequestWithoutManageAccess';
import { mapGetters } from "vuex";
import actionBar from '@/components/custom/action-bar';

export default {
  name: 'money-request',
  components: {
    'main-content': mainContent,
    'money-request-filter': moneyRequestFilter,
    'action-bar': actionBar,
    'money-request-with-manage': MoneyRequestWithManage,
    'money-request-without-manage': MoneyRequestWithoutManage,
  },
  data() {
    return {
      query: {},
    };
  },
  computed: {
    ...mapGetters('user', ['status']),
  },
  methods: {
    filterAction(e, query) {
      this.query = query;
      if (this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    },
  },
};
</script>
